import React, { Fragment } from 'react';

import styles from './userWatchlistPageStyles';

import Link from 'buyside/components/presentation/Link/link';
import TickerSearchSection from 'buyside/components/presentation/UserAccount/WatchlistedTickers/tickerSearchSection';

import XMarkIcon from 'buyside/svgs/x_mark.svg';

import { formatDate } from 'buyside/util/dateHelper';
import { get } from 'buyside/util/lodashAltJs';
import { entityUrl } from 'buyside/util/urlHelper';

const WATCHLIST_TABLE_COLUMNS = {
  SYMBOL: 'symbol',
  COMPANY: 'company',
  ADDED: 'added'
};

class WatchlistedTickersTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ascOrder: false,
      sortedList: null,
      currentSortColumn: ''
    };

    this.sortList = this.sortList.bind(this);
  }

  toggleSorting(column) {
    const { ascOrder, currentSortColumn } = this.state;

    if (currentSortColumn === column) {
      // if the same column is clicked consecutively, reverse the sorting direction
      this.setState({ ascOrder: !ascOrder }, this.sortList);
    } else {
      // if a different column is clicked, sort by the same direction as previously set
      this.setState({ currentSortColumn: column }, this.sortList);
    }
  }

  sortList() {
    const { sortedList, currentSortColumn, ascOrder } = this.state;
    const {
      currentUser: { watchlistTickers }
    } = this.props;
    const list = sortedList ? sortedList : [...watchlistTickers];

    let sortFunc;
    if (currentSortColumn === WATCHLIST_TABLE_COLUMNS.SYMBOL) {
      sortFunc = this.sortBySymbol;
    } else if (currentSortColumn === WATCHLIST_TABLE_COLUMNS.COMPANY) {
      sortFunc = this.sortByCompany;
    } else if (currentSortColumn === WATCHLIST_TABLE_COLUMNS.ADDED) {
      sortFunc = this.sortByAdded;
    }

    this.setState({ sortedList: list.sort(sortFunc(ascOrder)) });
  }

  sortBySymbol(order) {
    return (a, b) => {
      if (a.entity.primaryAsset && b.entity.primaryAsset) {
        if (a.entity.primaryAsset.primarySymbol < b.entity.primaryAsset.primarySymbol)
          return order ? 1 : -1;
        if (a.entity.primaryAsset.primarySymbol > b.entity.primaryAsset.primarySymbol)
          return order ? -1 : 1;
      } else {
        // if there is no primary asset, sort by company name
        if (a.entity.name < b.entity.name) return order ? 1 : -1;
        if (a.entity.name > b.entity.name) return order ? -1 : 1;
      }
      return 0;
    };
  }

  sortByCompany(order) {
    return (a, b) => {
      if (a.entity.name < b.entity.name) return order ? 1 : -1;
      if (a.entity.name > b.entity.name) return order ? -1 : 1;
      return 0;
    };
  }

  sortByAdded(order) {
    return (a, b) => {
      if (a.id < b.id) return order ? 1 : -1;
      if (a.id > b.id) return order ? -1 : 1;
      return 0;
    };
  }

  renderTable(tickerArr) {
    const { unfollowEntity } = this.props;
    return (
      <Fragment>
        {tickerArr.map(ticker => (
          <tr data-testid={`ticker-row-${ticker.entity.id}`} key={ticker.id}>
            <td>
              <Link to={entityUrl(ticker.entity.id)} className={styles.tickerLink}>
                {get(ticker, 'entity.primaryAsset.primarySymbol', '')}
              </Link>
            </td>
            <td>
              <Link to={entityUrl(ticker.entity.id)} className={styles.tickerLink}>
                {ticker.entity.name.toUpperCase()}
              </Link>
            </td>
            <td>{formatDate(ticker.createdAt)}</td>
            <td className={styles.lastColumn}>
              <div
                data-testid={`removeButton-${ticker.entity.id}`}
                onClick={() => unfollowEntity({ followId: ticker.entity.id })}
                className={styles.removeText}
              >
                <XMarkIcon className={styles.removeIcon} />
                <span>Remove</span>
              </div>
            </td>
          </tr>
        ))}
      </Fragment>
    );
  }

  render() {
    const {
      followEntity,
      currentUser: { followedEntityIds, watchlistTickers }
    } = this.props;
    const { ascOrder, currentSortColumn, sortedList } = this.state;

    return (
      <div>
        {!watchlistTickers.length ? (
          <div>
            <div className={styles.noTickerTitle}>
              <strong>Add Tickers to Your Watchlist for Important Updates</strong>
            </div>
            <p>
              The watchlist allows you to track the securities that are most important to you. Add a
              ticker to your watchlist and any relevant updates will appear in your activity feed on
              the SumZero homepage.
            </p>
          </div>
        ) : null}
        <TickerSearchSection followEntity={followEntity} userTickerEntityIds={followedEntityIds} />
        {watchlistTickers.length ? (
          <table className={styles.tickerTable}>
            <tbody>
              <tr>
                <th onClick={() => this.toggleSorting(WATCHLIST_TABLE_COLUMNS.SYMBOL)}>
                  Symbol{' '}
                  {currentSortColumn === WATCHLIST_TABLE_COLUMNS.SYMBOL
                    ? ascOrder
                      ? '↓'
                      : '↑'
                    : ''}
                </th>
                <th onClick={() => this.toggleSorting(WATCHLIST_TABLE_COLUMNS.COMPANY)}>
                  Company{' '}
                  {currentSortColumn === WATCHLIST_TABLE_COLUMNS.COMPANY
                    ? ascOrder
                      ? '↓'
                      : '↑'
                    : ''}
                </th>
                <th onClick={() => this.toggleSorting(WATCHLIST_TABLE_COLUMNS.ADDED)}>
                  Added{' '}
                  {currentSortColumn === WATCHLIST_TABLE_COLUMNS.ADDED
                    ? ascOrder
                      ? '↓'
                      : '↑'
                    : ''}
                </th>
                <th />
              </tr>
              {sortedList ? this.renderTable(sortedList) : this.renderTable(watchlistTickers)}
            </tbody>
          </table>
        ) : null}
      </div>
    );
  }
}

export default WatchlistedTickersTable;
